import {Theme} from '@material-ui/core'

export const styles = (theme: Theme) => ({
  portalButton: {
    fontSize: '18px',
    padding: '10px 30px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      padding: '10px 20px',
    },
  },
})
